import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import SvgToPng from '../../components/SvgToPng';

const SvgToPngPage: React.FC = () => (
  <ToolLayout
    title="SVG to PNG Converter Online Free | AllTools"
    description="Convert SVG vector files to PNG images. Custom dimensions supported. Free online SVG converter."
    canonicalPath="/svg-to-png"
  >
    <SvgToPng />
  </ToolLayout>
);

export default SvgToPngPage;
